import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetDevicesInformation = (data) => {
  return rootApi.get('api/device/search', { params: data });
};

export const apiGetDevicesInformationV2 = (data) => {
  return rootApi.get('api/v2/device/search', { params: data });
};

export const apiGetDevicesForMap = () => {
  return rootApi.get('api/device/map-data');
};

export const apiGetOriginalData = (data) => {
  return rootApi.get('api/original-data/search', { params: data });
};

export const apiExportOriginalData = (data) => {
  return rootApi.get('api/original-data/export-report', { params: data });
};

export const apiGetReturnCmd = (data) => {
  return rootApi.get('api/return-cmd/search', { params: data });
};

export const apiGetLinkDown = (data) => {
  return rootApi.get('api/down-link-command/search', { params: data });
};

export const apiCheckDeviceExist = (data) => {
  return rootApi.get('api/v2/device/check', { params: data });
};

export const apiCreateLinkDown = (data) => rootApi.post('api/down-link-command/create', data);

export const apiDeleteLinkDown = (id) => rootApi.delete(`api/down-link-command/delete/${id}`);

export const apiExportAdjustReport = (data) =>
  rootApi.get('api/down-link-command/export-adjust', { params: data });

export const apiGetDeviceInspections = (data) =>
  rootApi.get('api/device-inspections', { params: data });

export const apiGetUserInfo = (data) => {
  return rootApi.get('api/getUserInfo');
};

export const apiCreateDevice = (data) => rootApi.post('api/device', data);
export const apiUpdateDevice = (data, id) => rootApi.put(`api/device/${id}`, data);
export const apiDeleteDevice = (id, options = {}) =>
  rootApi.delete(`api/device/${id}`, {
    params: { unassignSim: options.unassignSim === true }
  });

export const apiGetDeviceById = (id) => {
  return rootApi.get(`api/device/${id}`);
};

export const apiDownloadTemplate = (data) => rootApi.post('api/device/export-template', data);
export const apiImportExcel = (data) => rootApi.post('api/device/import', data);

export const apiGetListCommunity = () => {
  return rootApi.get(`api/master-data/search?type=COMMUNITY`);
};

export const apiSyncData = () => rootApi.post('api/original-data/sync');

export const apiSyncTimeData = () => rootApi.post('api/original-data/sync-time');

export const apiGetAllReplacements = (data) => {
  return rootApi.get('api/replacements', { params: data });
};

export const apiCreateReplacement = (data) => rootApi.post('api/replacement', data);
export const apiUpdateReplacement = (data, id) => rootApi.put(`api/replacement/${id}`, data);
export const apiDeleteReplacement = (id) => rootApi.delete(`api/replacement/${id}`);

export const apiGetReplacementById = (id) => rootApi.get(`api/replacement/${id}`);

export const apiDownloadReplacementTemplate = (data) =>
  rootApi.post('api/replacement/export-template', data);
export const apiImportReplacementExcel = (data) => rootApi.post('api/replacement/import', data);

export const apiGetAllConfigs = (data) => {
  return rootApi.get('api/configs', { params: data });
};

export const apiCreateConfig = (data) => rootApi.post('api/config', data);
export const apiUpdateConfig = (data, id) => rootApi.put(`api/config/${id}`, data);
export const apiUpdateConfigV2 = (data, id) => rootApi.put(`api/v2/config/${id}`, data);
export const apiDeleteConfig = (id) => rootApi.delete(`api/config/${id}`);

export const apiGetConfigById = (id) => rootApi.get(`api/config/${id}`);

export const apiDownloadConfigTemplate = (data) => rootApi.post('api/config/export-template', data);
export const apiImportConfigExcel = (data) => rootApi.post('api/config/import', data);

export const apiGetAllWarnings = (data) => {
  return rootApi.get('api/device/warning/search', { params: data });
};

export const apiGetWarningsByTypeAndDate = (data) => {
  return rootApi.get('api/device/warning/by-type-and-date', { params: data });
};

export const apiResolvedWarning = (id, data) => rootApi.put(`api/device/warning/${id}`, data);

export const apiGetCategory = (data) => {
  return rootApi.get('api/master-data/category', { params: data });
};

// Device Status/Warranty APIs
export const apiUpdateDeviceStatus = (id, data) => rootApi.put(`api/device/${id}/status`, data);
export const apiUpdateDeviceCondition = (id, data) =>
  rootApi.put(`api/device/${id}/condition`, data);
export const apiImportDeviceStatus = (data) => rootApi.post('api/devices/import-status', data);
export const apiDownloadDeviceStatusTemplate = () =>
  rootApi.post('api/devices/export-status-template');

// Dashboard V2 Statistics APIs
export const apiGetDeviceStatisticsByBranch = (data) =>
  rootApi.get('api/device/statistics-by-branch', { params: data });

export const apiGetDeviceStatisticsByStatus = (data) =>
  rootApi.get('api/device/statistics-by-status', { params: data });

export const apiGetConsumptionByBranchByDay = (data) =>
  rootApi.get('api/customer/v2/consumption-by-branch-by-day', { params: data });

export const apiGetConsumptionComparisonByBranch = (data) =>
  rootApi.get('api/statistics-month/consumption-comparison-by-branch', { params: data });

export const apiGetCustomerStatisticsByDeviceInstallation = (data) =>
  rootApi.get('api/customers/statistics-by-device-installation', { params: data });

export const apiGetWarningStatisticsByType = (data) =>
  rootApi.get('api/device/warning/statistics-by-type', { params: data });

export const apiClearConsumptionCache = () =>
  rootApi.delete('api/customer/v2/consumption-by-branch-by-day/cache');
